var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconFilesCreativeCommonsLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconFilesCreativeCommons",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M960 0c529.355 0 960 430.645 960 960s-430.645 960-960 960S0 1489.355 0 960 430.645 0 960 0Zm0 112.941c-467.125 0-847.059 379.934-847.059 847.059 0 467.125 379.934 847.059 847.059 847.059 467.125 0 847.059-379.934 847.059-847.059 0-467.125-379.934-847.059-847.059-847.059ZM760.808 727c92.101-.046 158.033 35.78 197.89 107.502l-.046.023-99.63 51.81c-10.645-22.117-23.706-37.638-39.16-46.466-15.502-8.83-29.888-13.29-43.181-13.29-66.374 0-99.608 43.796-99.608 131.432 0 39.823 8.436 71.653 25.24 95.56 16.825 23.931 41.6 35.873 74.368 35.873 43.412 0 73.95-21.282 91.683-63.753L960 1072.158c-19.475 36.314-46.48 64.822-81.015 85.64-34.49 20.817-72.58 31.202-114.203 31.202-66.397 0-119.99-20.33-160.707-61.104C563.36 1087.236 543 1030.547 543 958.01c0-70.815 20.59-126.994 61.75-168.606C645.885 747.817 697.943 727 760.808 727Zm430.024 0c92.088-.046 157.656 35.781 196.588 107.507l-98.317 51.812c-10.599-22.119-23.708-37.64-39.165-46.468-15.573-8.83-30.401-13.29-44.51-13.29-66.404 0-99.641 43.796-99.641 131.436 0 39.825 8.436 71.656 25.241 95.564 16.805 23.932 41.605 35.874 74.377 35.874 43.372 0 73.912-21.283 91.623-63.755l92.972 46.468c-20.338 36.316-47.81 64.825-82.28 85.643a214.414 214.414 0 0 1-112.913 31.204c-67.312 0-121.095-20.33-161.306-61.107-40.372-40.66-60.501-97.352-60.501-169.89 0-70.82 20.57-127 61.78-168.613 41.163-41.567 93.157-62.385 156.052-62.385Z",
        stroke: "#979797",
        fillRule: "evenodd"
      }))
    });
  }
}
IconFilesCreativeCommonsLine.glyphName = 'files-creative-commons';
IconFilesCreativeCommonsLine.variant = 'Line';
IconFilesCreativeCommonsLine.displayName = 'IconFilesCreativeCommonsLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconFilesCreativeCommonsLine.propTypes = {
  ...SVGIcon.propTypes
};
IconFilesCreativeCommonsLine.allowedProps = [...SVGIcon.allowedProps];
export default IconFilesCreativeCommonsLine;
export { IconFilesCreativeCommonsLine };